import React from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// import { Link } from 'gatsby';

class Statement extends React.Component {
  componentDidMount() {
    if (typeof window !== `undefined`) {
      gsap.registerPlugin(ScrollTrigger);
      gsap.core.globals('ScrollTrigger', ScrollTrigger);
    }
    // const highlight = document.getElementById('highlight-style');

    gsap.utils.toArray('.text-highlight').forEach((highlight) => {
      ScrollTrigger.create({
        trigger: highlight,
        start: 'center 80%',
        // onEnter: () => highlight.classList.add('active'),
        // markers: true,
      });
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.statement__title',
        pin: true,
        scrub: 1,
        start: 'top =+35%',
        // end: '.statementEnd',
        endTrigger: '.statementEnd',
        toggleClass: 'stroke',
        // toggleActions: 'play pause play reset',
        toggleActions: 'play none none none',
        // markers: true,
      },
    });
  }
  render() {
    return (
      <div className="statement__wrap ">
        <h2 className="statement__title">
          全人類を
          <br className="sp" />
          {/* <mark className="text-highlight"> */}
          <span>"GOKIGEN"</span>
          {/* </mark> */}
          へと導く
        </h2>
        <div className="statementContent">
          <p>突然ですが一つ質問させてください。</p>
          <p>
            コロナ禍。
            <br />
            あなたにとって明らかになったのは
            <mark className="text-highlight">「正しい感染予防法」</mark>
            ですか？ それとも自身の
            <mark className="text-highlight">「免疫力の強さ」</mark>
            ですか？
          </p>
          <p>
            2020以降、今人類はコロナ社会の中で渦巻く外側の情報だけに目を奪われ、今日余りにも画一的で偏った在り様に引っ張られてはいないだろうか。
          </p>
          <p>
            本来、健康とは{' '}
            <mark className="text-highlight">"自分自身と向き合うコト"</mark>
            からのみ始まっていく。
          </p>
          <p>
            内なる声に静かに耳を傾け、深く意識することで辿り着ける
            <mark className="text-highlight">GOKIGEN</mark>
            という名の精神性。 そうしたマインドは今日の鬱屈した社会の中で
            <mark className="text-highlight">
              身体はもとより、心、思考、地域へ
            </mark>
            とその意味とカテゴリーを超え社会に拡張・再浸透されていくべきだと考えています。
          </p>
          <p>
            生産合理性の果てに低下した現代の食物では補いきれない栄養の不足により、我々に忍び寄る
            <mark className="text-highlight">あたらしい社会問題</mark>
            の解決に向けて。
          </p>
          <p className="statementEnd">
            サイレンサーは
            <mark className="text-highlight">
              "ヘルスケアをエンターテイメントに再編集"
            </mark>
            し、 内側と外側、あらゆる角度から
            <mark className="text-highlight">GOKIGENな空気を創造・創出</mark>
            していきます。
          </p>
        </div>
      </div>
    );
  }
}

export default Statement;
